import __request__ from 'routing/request';
interface NotificationsResponse {
    readonly total: number;
    readonly notifications: Notification[];
}
interface Validator {
}
interface Notification {
    readonly severity: 'normal' | 'urgent';
    readonly details: {
        readonly [_key: string]: Object;
    };
    readonly id: string;
    readonly validations: {
        readonly [_key: string]: Validator;
    };
    readonly type: 'data_node_needs_provisioning' | 'deflector_exists_as_index' | 'multi_master' | 'no_master' | 'es_open_files' | 'es_cluster_red' | 'es_unavailable' | 'no_input_running' | 'input_failed_to_start' | 'input_failing' | 'input_failure_shutdown' | 'check_server_clocks' | 'outdated_version' | 'email_transport_configuration_invalid' | 'email_transport_failed' | 'stream_processing_disabled' | 'gc_too_long' | 'journal_utilization_too_high' | 'journal_uncommitted_messages_deleted' | 'output_disabled' | 'output_failing' | 'index_ranges_recalculation' | 'generic' | 'generic_with_link' | 'es_index_blocked' | 'es_node_disk_watermark_low' | 'es_node_disk_watermark_high' | 'es_node_disk_watermark_flood_stage' | 'es_shard_allocation_maximum' | 'es_version_mismatch' | 'legacy_ldap_config_migration' | 'multi_leader' | 'no_leader' | 'archiving_summary' | 'search_error' | 'sidecar_status_unknown' | 'certificate_needs_renewal' | 'drawdown_license_error' | 'remote_reindex_running' | 'remote_reindex_finished' | 'data_node_version_mismatch' | 'data_tiering_rollover_error' | 'data_node_heap_warning';
    readonly fields: {
        readonly [_key: string]: Object;
    };
    readonly key: string;
    readonly timestamp: string;
    readonly node_id: string;
}
/**
 * Get all active notifications
 */
export function listNotifications(): Promise<NotificationsResponse> {
    return __request__('GET', '/system/notifications', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Delete a notification by type
 */
export function deleteNotification(notificationType?: string): Promise<void> {
    return __request__('DELETE', `/system/notifications/${notificationType}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Delete a notification by type and key
 */
export function deleteKeyedNotification(notificationType?: string, notificationKey?: string): Promise<void> {
    return __request__('DELETE', `/system/notifications/${notificationType}/${notificationKey}`, null, {}, {
        'Accept': ['application/json']
    });
}
